export const APIs = {
  MAIN_URL: process.env.REACT_APP_API_URL,
  // UPLOAD_SERVICE_URL: process.env.REACT_APP_API_UPLOAD_URL,
  // LOG_SERVER_URL: process.env.REACT_APP_LOG_API_URL,
};
console.log(
  'debug- process.env.REACT_APP_API_URL: ',
  process.env.REACT_APP_API_URL,
);
console.warn('process.env.REACT_APP_API_URL', process.env.REACT_APP_API_URL);

const urls = {
  archiveFile: 'archive/file/',

  orderList: '/admin/order/list',
};

export default urls;
